import {createSelector} from 'reselect';
import props from '../../props';

export default createSelector(
    props.lucky_wheel.rewards,
    (rewards) => {
        return {
            rewards
        }
    }
)